import React from 'react';
import { PerspectivesCheckboxFilter } from 'components/controls/filters/perspectives-checkbox-filter';
import SelectComponent from 'components/controls/select-component/';
import checkboxFilterStyles from 'components/controls/filters/perspectives-checkbox-filter/perspectives-checkbox-filter.module.scss';
import FlexContainer from 'components/containers/flex-container';
import ClearableFilters from 'components/controls/filters/clearable-filters';
import EqualWidthColumns from 'components/containers/equal-width-columns';
import type { Props } from 'react-select';
import Subsection from 'components/containers/sub-section';
import styles from './page.module.scss';
import { PERSPECTIVES_MEDIA_TYPES } from './_media-types';

export const Filters = ({
	selectedMediaType,
	handleCheckboxChange,
	topicFilters,
	departmentFilters,
	selectedTopic,
	selectedDepartment,
	handleClearAll,
	handleClearTopic,
	handleClearDepartment,
	handleTopicSelectChange,
	handleDepartmentSelectChange,
	handleRemoveSelection,
}: IFiltersProps) => {
	//Formats Selected options for Clearable Filter
	const selectedDepartmentWithFormattedName =
		departmentFilters.find(
			(department) => department?.value.toLowerCase() === selectedDepartment,
		) || '';
	const selectedTopicWithFormattedName =
		topicFilters.find(
			(topic) => topic?.value.toLowerCase() === selectedTopic,
		) || '';

	return (
		<div className={styles.filterWrapper}>
			<Subsection>
				<EqualWidthColumns fullWidth={true}>
					<SelectComponent
						fieldName="Topic"
						options={topicFilters}
						isClearable={true}
						onChange={handleTopicSelectChange}
						value={
							topicFilters.find(
								(topic) => topic?.value.toLowerCase() === selectedTopic,
							) || ''
						}
						id="topic-select"
					/>
					<SelectComponent
						fieldName="Department"
						options={departmentFilters}
						isClearable={true}
						onChange={handleDepartmentSelectChange}
						value={
							departmentFilters.find(
								(department) =>
									department?.value.toLowerCase() === selectedDepartment,
							) || ''
						}
						id="department-select"
					/>
				</EqualWidthColumns>

				<section className={checkboxFilterStyles.container}>
					<fieldset className={checkboxFilterStyles.fieldset}>
						<legend className={checkboxFilterStyles.legend}>Media Type</legend>
						<div className={checkboxFilterStyles.filters}>
							{PERSPECTIVES_MEDIA_TYPES.map((filter) => (
								<PerspectivesCheckboxFilter
									key={filter.value}
									filter={filter}
									handleCheckboxChange={handleCheckboxChange}
									selectedMediaType={selectedMediaType}
									tooltipID={filter.value}
								/>
							))}
						</div>
					</fieldset>
					<FlexContainer gap="var(--spacing-micro)" wrap="wrap">
						{selectedTopic && (
							<ClearableFilters
								groupName="topics"
								handleClearAll={handleClearAll}
								handleClose={handleClearTopic}
								selectedValues={[selectedTopicWithFormattedName]}
							/>
						)}
						{selectedDepartment && (
							<ClearableFilters
								groupName="department"
								handleClearAll={handleClearAll}
								handleClose={handleClearDepartment}
								selectedValues={[selectedDepartmentWithFormattedName]}
							/>
						)}
						<ClearableFilters
							groupName="media"
							handleClearAll={handleClearAll}
							handleClose={handleRemoveSelection}
							selectedValues={PERSPECTIVES_MEDIA_TYPES.filter((mediaFilter) =>
								selectedMediaType.includes(mediaFilter.value),
							)}
						/>
					</FlexContainer>
				</section>
			</Subsection>
		</div>
	);
};

interface IFiltersProps {
	selectedMediaType: any[];

	handleCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	topicFilters: any[];
	departmentFilters: any[];
	selectedTopic: string;
	selectedDepartment: string;
	handleClearAll: () => void;
	handleClearTopic: () => void;
	handleClearDepartment: () => void;
	handleTopicSelectChange: Props['onChange'];
	handleDepartmentSelectChange: Props['onChange'];

	handleRemoveSelection: (item: any) => void;
}
